import React, { useEffect, useState } from "react";
import { Col, ConfigProvider, DatePicker, Divider, Flex, Modal, Row, Table } from "antd";
import Input from "../../../../components/Input/Input";
import { DownOutlined, SearchOutlined, UnorderedListOutlined } from "@ant-design/icons";
import Text from "../../../../components/Text/Text";
import Select from "../../../../components/Select/Select";
import { color, icon } from "../../../../resource";
import Button from "../../../../components/Button/Button";
import { FlexCol } from "../../../../components/Container/Container";

export const CouponTab = () => {
  const [modalCancelReason, setModalCancelReason] = useState({ open: false, reason: "", name: "" });

  const mockData = [
    {
      key: "1",
      shopId: "S001",
      shopName: "ร้านค้า 1",
      zone: "เขต 1",
      redeemDate: "01/01/2024",
      couponCode: "C001",
      prize: "ของรางวัล 1",
      value: 500,
      pointsUsed: 100,
      expiryDate: "31/12/2024",
      dealer: "ร้านค้า Dealer 1",
      status: "Active",
      reference: "REF001",
      points: 100,
      operator: "ผู้ดำเนินการ 1",
    },
    {
      key: "2",
      shopId: "S002",
      shopName: "ร้านค้า 2",
      couponCode: "C002",
      prize: "ของรางวัล 2",
      value: 300,
      pointsUsed: 80,
      expiryDate: "31/12/2024",
      dealer: "ร้านค้า Dealer 2",
      zone: "เขต 2",
      redeemDate: "01/01/2024",
      status: "Active",
      reference: "REF002",
      points: 150,
      operator: "ผู้ดำเนินการ 2",
    },
  ];

  const columns = [
    {
      title: "วันที่แลก",
      dataIndex: "redeemDate",
      key: "redeemDate",
    },
    {
      title: "ร้านค้าที่แลก (Sub-Dealer)",
      dataIndex: "shopName",
      key: "shopName",
    },
    {
      title: "รหัสคูปอง",
      dataIndex: "couponCode",
      key: "couponCode",
    },
    {
      title: "ของรางวัล",
      dataIndex: "prize",
      key: "prize",
    },
    {
      title: "มูลค่า",
      dataIndex: "value",
      key: "value",
    },
    {
      title: "แต้มที่ใช้",
      dataIndex: "pointsUsed",
      key: "pointsUsed",
    },
    {
      title: "วันหมดอายุ",
      dataIndex: "expiryDate",
      key: "expiryDate",
    },
    {
      title: "ร้านที่ตัดใช้/ปฎิเสธ (Dealer)",
      dataIndex: "dealer",
      key: "dealer",
      render: (value: any) => (
        <FlexCol>
          <Text>{value}</Text>
          <Text
            level={6}
            onClick={() =>
              setModalCancelReason({ open: true, name: "ร้านค้า 1", reason: "ส่วนตัว" })
            }
          >
            ปฏิเสธ <u style={{ cursor: "pointer", color: color.primary }}>ดูเหตุผล</u>
          </Text>
        </FlexCol>
      ),
    },
    {
      title: "สถานะ",
      dataIndex: "status",
      key: "status",
    },
  ];
  return (
    <>
      <Row justify='space-between' gutter={8}>
        <Col span={6}>
          <Input
            autoComplete='off'
            placeholder='รหัส / ชื่อร้าน Sub-Dealer'
            suffix={<SearchOutlined />}
          />
        </Col>
        <Col span={3}>
          <Select data={[]} placeholder='เลือกเขต' />
        </Col>
        <Col span={5}>
          <Select data={[]} placeholder='สถานะทั้งหมด' />
        </Col>
        <Col span={1} />
        <Col>
          <DatePicker.RangePicker
            format='DD/MM/YYYY'
            allowClear={false}
            allowEmpty={[true, true]}
            style={{ width: "100%", color: color.BK, height: "40px" }}
            //value={[period[0] ? dayjs(period[0]) : null, period[1] ? dayjs(period[1]) : null]}
          />
        </Col>
        <Col>
          <Button
            title='ดาวน์โหลด'
            icon={<img src={icon.downloadFileIcon} style={{ width: 18, height: 18 }} />}
            typeButton='primary-light'
          />
        </Col>
      </Row>
      <br />
      <ConfigProvider
        theme={{
          components: {
            Table: {
              headerBg: "#F3F6F9",
              fontFamily: "IBM Plex Sans Thai",
              fontSize: 15,
            },
          },
        }}
      >
        <Table
          columns={columns}
          dataSource={mockData}
          scroll={{ x: "max-content" }}
          pagination={{
            pageSize: 10,
            current: 1,
            total: 20,
            showSizeChanger: false,
            position: ["bottomCenter"],
            // onChange: (page) => {
            //   const nextPage = String(page);
            //   //setPage(nextPage);
            //   //setParams({ page: nextPage });
            // },
          }}
        />
      </ConfigProvider>
      {modalCancelReason.open && (
        <Modal
          centered
          closable={false}
          open={modalCancelReason.open}
          onCancel={() => setModalCancelReason({ open: false, reason: "", name: "" })}
          footer={null}
        >
          <FlexCol style={{ alignItems: "center" }}>
            <Text level={3} fontWeight={700}>
              เหตุผลปฎิเสธไม่ตัดใช้คูปอง
            </Text>
            <Text level={4}>ชื่อร้านค้า: {modalCancelReason.name}</Text>
            <Divider />
          </FlexCol>
          <Text fontWeight={700}>เหตุผล</Text>
          <br />
          <Text>{modalCancelReason.reason}</Text>
          <Divider />
          <Button
            title='ปิด'
            typeButton='primary'
            onClick={() => setModalCancelReason({ open: false, reason: "", name: "" })}
          />
        </Modal>
      )}
    </>
  );
};
